import React, { useState } from 'react';
import { Trash2 } from 'lucide-react';

export default function DeleteButton({ onDelete, label = 'Delete' }) {
  const [confirm, setConfirm] = useState(false);

  if (confirm) {
    return (
      <div className="flex items-center gap-1">
        <span className="text-xs text-red-600 dark:text-red-400">Sure?</span>
        <button
          onClick={() => {
            onDelete();
            setConfirm(false);
          }}
          className="text-xs text-red-600 dark:text-red-400 hover:underline font-medium"
        >
          Yes
        </button>
        <button
          onClick={() => setConfirm(false)}
          className="text-xs text-[var(--text-secondary)] hover:underline"
        >
          No
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={() => setConfirm(true)}
      className="p-1 rounded text-[var(--text-tertiary)] hover:text-red-500 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-smooth"
      aria-label={label}
    >
      <Trash2 className="w-3.5 h-3.5" />
    </button>
  );
}